// ==============================|| THEME CONSTANT ||============================== //

//export const APP_DEFAULT_PATH = '/dashboard/default';
export const APP_DEFAULT_PATH = '/';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;


const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
